import { FastField, Field, FieldAttributes } from "formik";
import React from "react";

interface FProps extends FieldAttributes<any> {
  name: string;
  optimise?: boolean;
}

const OptimisedField: React.FC<FProps> = ({ children, optimise, name }) => {
  if (optimise) {
    return (
      <div>
        <FastField name={name}>{children}</FastField>
      </div>
    );
  } else {
    return <Field name={name}>{children}</Field>;
  }
};

export default OptimisedField;
